import React from 'react';
import { useCustomComponentStateContext } from '../hooks/useCustomComponentState';
import GlobalStyleTag from './GlobalStyleTag';
import CustomCarousel from './CustomCarousel';

function Json() {
  const { state, signalContentLoaded } = useCustomComponentStateContext();

  const { type = '' } =
    state?.queryData?.retailerSettings?.productRecommendations || {};

  const supportedTypes = ['JSON', 'CERTONA', 'ML_ENGINE'];

  if (!supportedTypes.includes(type)) return null;

  if (signalContentLoaded) signalContentLoaded();

  return (
    <>
      <GlobalStyleTag />
      <CustomCarousel />
    </>
  );
}

export default Json;
